import React from 'react'
import Caption from '../Typography/Caption'
import FormatCurrency from 'components/Common/FormatCurrency'

interface Props {
  value: number
  /**
   * @default roundedDollar
   */
  priceFormat?: React.ComponentProps<typeof FormatCurrency>['format']
  /**
   * @default neutral-two
   */
  colour?: 'neutral-two' | 'neutral-three';
}

function PriceRowSale(props: Props) {
  const { value, priceFormat = 'roundedDollar', colour = 'neutral-two' } = props

  return <Caption
    as="s"
    variant="large"
    colour={colour}
  >
    Was <FormatCurrency value={value} format={priceFormat} />
  </Caption>
}

export default PriceRowSale
